/**
 * @generated SignedSource<<ae5eacd6b23ae2e063c6af3f16cd3a46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerAllMenuColumnistsQuery$data = {
  readonly columnistsQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name?: string;
          readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "entityLink">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "headerAllMenuColumnistsQuery";
};
export type headerAllMenuColumnistsQuery$key = {
  readonly " $data"?: headerAllMenuColumnistsQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuColumnistsQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerAllMenuColumnistsQuery",
  "selections": [
    {
      "alias": "columnistsQueue",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "name": "scmp_columnists"
          }
        }
      ],
      "concreteType": "Queue",
      "kind": "LinkedField",
      "name": "queue",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 7
            }
          ],
          "concreteType": "QueueItemConnection",
          "kind": "LinkedField",
          "name": "items",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "QueueItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "entityLink"
                        },
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "authorAvatarAuthor"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        }
                      ],
                      "type": "Author",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "items(first:7)"
        }
      ],
      "storageKey": "queue(filter:{\"name\":\"scmp_columnists\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "67e999d91cea8219e3eb9b532d54f2cf";

export default node;
